import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import AxiosPlugin from './plugins/AxiosPlugin'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './assets/js/bootstrap.js';
import './assets/css/bootstrap.css';
import '@/assets/font/font.css'
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.use(AxiosPlugin);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
